import {ModuleWithProviders, NgModule} from '@angular/core';
import {A11yModule} from '@angular/cdk/a11y';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatAutocompleteModule} from '@angular/material';
import {MatBadgeModule} from '@angular/material';
import {MatBottomSheet, MatBottomSheetModule, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA} from '@angular/material';
import {MatButtonModule} from '@angular/material';
import {MatButtonToggleModule} from '@angular/material';
import {MatCardModule} from '@angular/material';
import {MatCheckboxModule} from '@angular/material';
import {MatChipsModule} from '@angular/material';
import {MatStepperModule} from '@angular/material';
import {MatDatepickerModule} from '@angular/material';
import {MatDialog, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {MatDividerModule} from '@angular/material';
import {MatExpansionModule} from '@angular/material';
import {MatGridListModule} from '@angular/material';
import {MatIconModule, MatIconRegistry} from '@angular/material';
import {MatInputModule} from '@angular/material';
import {MatListModule} from '@angular/material';
import {MatMenuModule} from '@angular/material';
import {MatNativeDateModule, MatRippleModule, RippleGlobalOptions, MAT_RIPPLE_GLOBAL_OPTIONS, MAT_DATE_FORMATS, DateAdapter} from '@angular/material';
import {MatPaginatorModule} from '@angular/material';
import {MatProgressBarModule} from '@angular/material';
import {MatProgressSpinnerModule} from '@angular/material';
import {MatRadioModule} from '@angular/material';
import {MatSelectModule} from '@angular/material';
import {MatSidenavModule} from '@angular/material';
import {MatSliderModule} from '@angular/material';
import {MatSlideToggleModule} from '@angular/material';
import {MatSnackBar, MatSnackBarModule, MatSnackBarRef} from '@angular/material';
import {MatSortModule} from '@angular/material';
import {MatTableModule} from '@angular/material';
import {MatTabsModule} from '@angular/material';
import {MatToolbarModule} from '@angular/material';
import {MatTooltipModule} from '@angular/material';
import {MatTreeModule} from '@angular/material';
// import { I18NFormDirective } from './providers/i18n.form.directive';
// import { I18NPipe } from './providers/i18n.pipe';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
// import { I18NDirective } from './i18n.directive';

import { I18NDirective, I18NPipe, I18NFieldPipe, PluginBaseModule } from 'ess-plugin-base';
// import { I18NDirective, I18NPipe, PluginBaseModule } from 'ess-plugin-base';
// import { I18NPipe } from './providers/i18n.pipe';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatFormFieldModule } from '@angular/material';
// import { I18NFieldPipe } from 'ess-plugin-base';

// import { QRCodeModule } from 'angularx-qrcode';

const globalRippleConfig: RippleGlobalOptions = {
    disabled: false,
    animation: {
      enterDuration: 300,
      exitDuration: 900
    }
  };

  export const MY_FORMATS = {
    parse: {
      dateInput: 'LL',
    },
    display: {
      dateInput: 'D MMM YYYY',
      monthYearLabel: 'YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'YYYY',
    },
  };

@NgModule({
  declarations: [
    // I18NDirective,
    // I18NFormDirective,
    // I18NPipe
  ],
  imports: [
    PluginBaseModule,
    
    A11yModule,
    OverlayModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,

    MatMomentDateModule,

    NgxMaterialTimepickerModule
  ],
  exports: [
    // The following declared in base module..
    I18NDirective,
    // I18NFormDirective,
    I18NPipe, I18NFieldPipe,

    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    CdkAccordionModule,
    OverlayModule,

    DragDropModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,

    MatMomentDateModule,
    // QRCodeModule
    NgxMaterialTimepickerModule
  ],
  providers: [
    {provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig},
    {provide: DateAdapter, useClass: MomentDateAdapter},
                          // {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
                          // {provide: DateAdapter, useClass: MomentDateAdapter},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
                          // {provide: MAT_DIALOG_DATA, useValue: {}}
  ]
})
export class ImportMaterialModule {

  // static forRoot() {
  //   return {
  //     ngModule: ImportMaterialModule,
  //     providers: [
  //       { provide: MatSnackBar, useClass: MatSnackBar },
  //       { provide: MatDialog, useClass: MatDialog },
  //       { provide: MAT_DIALOG_DATA, useValue: {} },
  //       { provide: MatBottomSheetRef, useValue: {} },
  //       { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
  //       { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
  //       { provide: DateAdapter, useClass: MomentDateAdapter },
  //       { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  //     ]
  //   }
  // }
}